const Maintenance = () => {
    return <h1>This site is currently under maintenance.</h1>;
};

export default Maintenance;
